export const OPEN_ACCOUNT_MODULE_NAME = 'openAccount';

export enum OpenAccountGetter {
	invoiceList = 'invoiceList',
	invoice = 'invoice',
	invoiceItem = 'invoiceItem',
	step = 'step',
	phoneNumber = 'phoneNumber',
	requestData = 'requestData',
	legalEntity = 'legalEntity',
	legalEntityLoading = 'legalEntityLoading',
	legalEntityLoadingHint = 'legalEntityLoadingHint',
	legalEntityLoadingHintList = 'legalEntityLoadingHintList',
}

export enum OpenAccountMutation {
	setInvoiceList = 'setInvoiceList',
	setInvoice = 'setInvoice',
	setStep = 'setStep',
	setPhoneNumber = 'setPhoneNumber',
	setRequestData = 'setRequestData',
	setLegalEntity = 'setLegalEntity',
	setLegalEntityLoading = 'setLegalEntityLoading',
	setLegalEntityLoadingHint = 'setLegalEntityLoadingHint',
}

export enum OpenAccountAction {
	loadInvoiceList = 'loadInvoiceList',
	loadInvoice = 'loadInvoice',
	sendConfirmationCode = 'sendConfirmationCode',
	verifyConfirmationCode = 'verifyConfirmationCode',
	loadLegalEntity = 'loadLegalEntity',
	createApplication = 'createApplication',
}